import React, {Component} from "react";
import {connect} from "react-redux";

import * as componentTypes from "../../constants/componentTypes";
import * as navigationActions from "../../actions/navigationActions";
import * as helperActions from "../../actions/helperActions";
import * as config from "../../constants/config";

import HelpModalComponent from "../../components/global/modal/HelpModal";
import HelpModalGammaComponent from "../../components/global/modal/HelpModalGamma";

class HelpModal extends Component {
    closeModal = () => {
        this.props.dispatchCloseHelpModalAction();
    };

    getHelperIsOnline = () => {
        this.props.dispatchGetHelperIsOnlineAction();
    };

    openBugReportSection = () => {
        this.props.dispatchOpenBugReportSectionAction();
        this.closeModal();
    };

    render() {
        if (this.props.colorisSoftware) {
            if (this.props.redlikeLightSoftware) {
                return (
                    <HelpModalComponent
                        tabId={this.props.tabId}
                        params={this.props.params}
                        helpSettings={this.props.helpSettings}
                        closeModal={this.closeModal}
                        helpLink={this.props.helpLink}
                        displayHelpLink={false}
                        id={this.props.id}
                        lightSoftware={true}
                    />
                );
            }

            return (
                <HelpModalComponent
                    tabId={this.props.tabId}
                    params={this.props.params}
                    helpSettings={this.props.helpSettings}
                    closeModal={this.closeModal}
                    helpLink={this.props.helpLink}
                    displayHelpLink={false}
                    id={this.props.id}
                />
            );
        }

        if (this.props.redlikeLightSoftware) {
            return (
                <HelpModalComponent
                    tabId={this.props.tabId}
                    params={this.props.params}
                    helpSettings={this.props.helpSettings}
                    closeModal={this.closeModal}
                    helpLink={this.props.helpLink}
                    displayHelpLink={true}
                    id={this.props.id}
                    lightSoftware={true}
                />
            );
        }

        if (this.props.gammaSoftware) {
            return (
                <HelpModalGammaComponent
                    tabId={this.props.tabId}
                    params={this.props.params}
                    helpSettings={this.props.helpSettings}
                    helpLink={this.props.helpLink}
                    loggedUser={this.props.loggedUser}
                    helperIsOnline={this.props.helperIsOnline}
                    getHelperIsOnline={this.getHelperIsOnline}
                    closeModal={this.closeModal}
                    openBugReportSection={this.openBugReportSection}
                    id={this.props.id}
                />
            );
        }

        return (
            <HelpModalComponent
                tabId={this.props.tabId}
                params={this.props.params}
                helpSettings={this.props.helpSettings}
                closeModal={this.closeModal}
                helpLink={this.props.helpLink}
                displayHelpLink={true}
                id={this.props.id}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        redlikeLightSoftware: store.module.redlikeLightSoftware,
        gammaSoftware: store.module.gammaSoftware,
        colorisSoftware: store.module.colorisSoftware,
        helpSettings: store.settings.helpSettings,
        helpLink: store.settings.helpLink || config.HELP_ON_REDLIKE,
        loggedUser: store.login.loggedUser,
        helperIsOnline: store.helper.isOnline
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseHelpModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.HELP_MODAL));
        },
        dispatchOpenBugReportSectionAction: () => {
            dispatch(navigationActions.addNewBugReportTab());
        },
        dispatchGetHelperIsOnlineAction: () => {
            dispatch(helperActions.isHelperOnline());
        }
    };
};

export default HelpModal = connect(mapStoreToProps, mapDispatchToProps)(HelpModal);
